import React from 'react';
import { useTranslation } from 'react-i18next';

// 用户图标组件，支持显示单人图标和倍数
export const UsersIcon = ({ count = 1, className = "w-6 h-6", color = "currentColor" }) => {
  // 所有情况都使用单人图标作为基础，倍数显示在右侧
  return (
    <div className="flex items-center gap-1">
      {/* 单人图标 */}
      <svg className={className} fill="none" viewBox="0 0 24 24" stroke={color} strokeWidth={2}>
        <circle cx="12" cy="8" r="3" stroke={color} strokeWidth="2" fill="none" />
        <path d="M6 20v-2c0-2.2 1.8-4 4-4h4c2.2 0 4 1.8 4 4v2" stroke={color} strokeWidth="2" strokeLinecap="round" />
      </svg>
      
      {/* 显示倍数 */}
      <span className="text-sm font-bold text-gray-700">
        ×{count}
      </span>
    </div>
  );
};

// 用户数量显示组件 - 图标和文字分开
export const UserCountDisplay = ({ count, size = "md" }) => {
  const { t } = useTranslation();
  const sizeClasses = {
    sm: "gap-2 text-xs",
    md: "gap-3 text-sm",
    lg: "gap-4 text-base"
  };
  
  const iconSizes = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10"
  };
  
  const getText = (count) => {
    if (count === 1) return t('homepage.productGrid.userCount.single');
    return t('homepage.productGrid.userCount.shared', { count });
  };
  
  return (
    <div className={`flex flex-col items-center ${sizeClasses[size]}`}>
      <div className="bg-white rounded-xl p-2 shadow-sm border border-gray-100">
        <UsersIcon count={count} className={`${iconSizes[size]} text-gray-600`} />
      </div>
      <span className="font-medium text-gray-700 text-center">{getText(count)}</span>
    </div>
  );
};

// 带背景的用户数量标签组件（保留兼容性）
export const UserCountBadge = ({ count, size = "md" }) => {
  return <UserCountDisplay count={count} size={size} />;
};

export default UsersIcon;